export function updateAllLocations(state, { locations }) {
  state.all = locations;
}

export function setCurrentLocation(state, location) {
  state.current = location;
}
